import { useMemo, useState } from "react";
import Input from "../Form/Input/Input";
import {
  buildFieldDefinitions,
  createInitialValues,
  createSubmittedFields,
  validateFields,
} from "../Form/formFields";
import "../Form/Form.css";
import "./ConsultationForm.css";

const QUESTION_FIELDS = [
  ["problem", "شو المشكلة اللي حابب تحلها؟"],
  ["reason", "شو السبب لهالمشكلة من وجهة نظرك؟"],
  ["attempts", "شو جربت قبل لتحلها وما زبط معك؟"],
  [
    "successResult",
    "شو النتيجة اللي بدك تصير بنهاية الاستشارة لتعتبرها استشارة ناجحة؟",
  ],
];

function ConsultationForm({ phone, components = [] }) {
  const fields = useMemo(
    () => buildFieldDefinitions(components),
    [components]
  );
  const fieldsByComponentIndex = useMemo(
    () => new Map(fields.map((field) => [field.componentIndex, field])),
    [fields]
  );
  const [values, setValues] = useState(() => createInitialValues(fields));
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  const handleFieldChange = (fieldName, value) => {
    setValues((currentValues) => ({ ...currentValues, [fieldName]: value }));
    setErrors((currentErrors) => ({ ...currentErrors, [fieldName]: "" }));
    setStatus("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const validationErrors = validateFields(fields, values);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setStatus("");
      return;
    }

    const submittedFields = createSubmittedFields(fields, values);
    const messageLines = ["طلب لحجز استشارة وضوح", ""];

    QUESTION_FIELDS.forEach(([field, question]) => {
      messageLines.push(question, submittedFields[field] || "", "");
    });

    const whatsappNumber = String(phone || "").replace(/[^\d]/g, "");

    if (!whatsappNumber) {
      setStatus("تعذر تجهيز رابط واتساب. رقم واتساب غير موجود.");
      return;
    }

    const whatsappUrl =
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        messageLines.join("\n").trim()
      )}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    setStatus("تم تجهيز رسالة الحجز. أرسلها عبر واتساب لإتمام الطلب.");
  };

  return (
    <form className="lp-form consultation-form" noValidate onSubmit={handleSubmit}>
      {components.map((component, componentIndex) => {
        if (component?.name === "input") {
          const field = fieldsByComponentIndex.get(componentIndex);

          return field ? (
            <Input
              error={errors[field.fieldName]}
              field={field}
              key={componentIndex}
              onChange={(value) => handleFieldChange(field.fieldName, value)}
              value={values[field.fieldName]}
            />
          ) : null;
        }

        if (component?.name === "button") {
          return (
            <button className="lp-form-submit" key={componentIndex} type="submit">
              {component.text || "حجز استشارة"}
            </button>
          );
        }

        return null;
      })}

      {status && <p className="consultation-form-status">{status}</p>}
    </form>
  );
}

export default ConsultationForm;
